import { useTranslation } from "react-i18next";
import { getNetworkErrorDescription } from "@keycloak/keycloak-ui-shared";
import { Box, Typography } from "@mui/material";
import Modal from "../components/modal/Modal";

type ErrorPageProps = {
  error?: unknown;
};

export const ErrorPage = (props: ErrorPageProps) => {
  const { t } = useTranslation();
  const error = props.error;
  const errorMessage =
    getErrorMessage(error) ||
    getNetworkErrorDescription(error)?.replace(/\+/g, " ");
  console.error(error);

  function onRetry() {
    location.href = location.origin + location.pathname;
  }

  return (
    <Box>
      <Modal
        title={errorMessage ? "" : t("somethingWentWrong")}
        isOpen
        showCancelBtn={false}
        showCloseBtn={false}
        confirmText={t("tryAgain")}
        onConfirm={onRetry}>
        {errorMessage ? (
          <Typography>{t(errorMessage)}</Typography>
        ) : (
          <Typography>{t("somethingWentWrongDescription")}</Typography>
        )}
      </Modal>
    </Box>
  );
};

function getErrorMessage(error: unknown): string | null {
  if (typeof error === "string") {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return null;
}
